module.exports = __webpack_public_path__ + "img/3beaf80.jpg";